import { render, staticRenderFns } from "./CreateRawMaterialPopUp.vue?vue&type=template&id=4a2046f4&scoped=true"
import script from "./CreateRawMaterialPopUp.vue?vue&type=script&lang=js"
export * from "./CreateRawMaterialPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateRawMaterialPopUp.vue?vue&type=style&index=0&id=4a2046f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2046f4",
  null
  
)

export default component.exports